<script setup lang="ts">
import { useCreateAlert } from "@/api/alert-query";
import { mdiAlertPlus } from "@mdi/js";
import { useForm } from "@soft-db/form";
import { CreateAlert } from "@soft-db/monitoring-api-client";
import { computed } from "vue";
import { useRoute } from "vue-router";
import { z } from "zod";
import AppDialog from "../common/AppDialog.vue";
const emit = defineEmits<{
	created: [id: string];
}>();

const dialog = defineModel<boolean>("dialog");

const route = useRoute();

const siteId = computed(() => route.params.id as string);

const { useField, handleSubmit, valid, clear } = useForm<CreateAlert>();

const name = useField("name", { schema: z.string().trim().min(1) });

function close() {
	dialog.value = false;
	clear();
}

const alertCreation = useCreateAlert();

const createAlert = handleSubmit(async (alert) => {
	const createdAlert = await alertCreation.mutateAsync({
		site: siteId.value,
		alert,
	});

	emit("created", createdAlert.id);
	close();
});
</script>

<template>
	<AppDialog
		v-model="dialog"
		class="w-100"
		persistent
		:actionText="$t('common.create')"
		:actionDisabled="!valid"
		@close="clear"
		@click:action="createAlert"
	>
		<template #title>
			{{ $t("actions.createAlert") }} <SoftIcon class="ml-2">{{ mdiAlertPlus }}</SoftIcon>
		</template>
		<template #content>
			<form @submit="createAlert">
				<input hidden type="submit" />
				<SoftInput v-bind="name.attrs" :label="$t('common.name')" required />
			</form>
		</template>
	</AppDialog>
</template>
